import React, { createContext, useContext, useCallback } from "react";
import { ToastContainer, toast, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

interface ToastContextType {
  notify: (message: string, options?: ToastOptions) => void;
}
const ToastContext = createContext<ToastContextType>({
  notify: () => {}, // no-op default function
});
export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }: any) => {
  const notify = useCallback((message: any, options: any) => {
    toast(message, options);
  }, []);

  return (
    <ToastContext.Provider value={{ notify }}>
      {children}
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnHover={false}
      />
    </ToastContext.Provider>
  );
};
